import Popup from './Popup';
import PlumPrint from './PlumPrint';
import MetricsPanel from './MetricsPanel';
import type {
  WidgetMetrics,
  WidgetData,
  WidgetConfig,
  IdentifierType,
  WidgetTheme,
} from '../types';
import styles from '../styles/widget.module.scss';

interface BadgeProps {
  metrics: WidgetMetrics;
  data: WidgetData;
  config: WidgetConfig;
  printSize?: 'xs' | 'sm' | 'md' | 'lg';
  identifier: string;
  identifierType: IdentifierType;
  theme?: WidgetTheme;
}

const Badge = ({
  metrics,
  data,
  config,
  printSize = 'sm',
  identifier,
  identifierType,
  theme,
}: BadgeProps) => (
  <Popup
    trigger={
      <div className={styles.badge}>
        <PlumPrint metrics={metrics} size={printSize} />
        <span className={styles.badgeText}>PlumX Metrics</span>
      </div>
    }
    direction={config.popupDirection}
    theme={theme}
  >
    <MetricsPanel
      metrics={metrics}
      data={data}
      config={config}
      identifier={identifier}
      identifierType={identifierType}
      theme={theme}
    />
  </Popup>
);

export default Badge;
